module.exports = __webpack_public_path__ + "img/pic4.2b7bab3b.png";